import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import plugins from './plugins'
import utils from '@/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins,
  actions: {
    // for more information: https://github.com/vuejs/vuex/issues/1118
    resetAllStates ({ commit, dispatch }) {
      dispatch('report/resetState')
      dispatch('user/resetState')
      dispatch('metadata/resetState')
      dispatch('workspaces/resetState')
      dispatch('search/resetState')
    }
  },
  strict: utils.vuex.strict
})
